module.exports = {"year":{"many":"{0} л.","other":"{0} г."},"month":"{0} мес.","week":"{0} нед.","day":{"one":"{0} д.","other":"{0} дн."},"hour":"{0} ч.","minute":"{0} мин.","second":"{0} сек.","now":{"past":"только что","future":"сейчас"}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/javascript-time-ago/locale-more-styles/ru/short-time.json
// module id = 688
// module chunks = 0